export default {
  config: {
    options: {
      label: 'Thématique'
    }
  },
  dataModel: {
    types: ['pair:Theme'],
    fieldsMapping: {
      title: 'pair:label'
    }
  }
};
